<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.25012 7.70008V12.6154C2.25012 13.3801 2.92169 14 3.75012 14H14.2501C15.0786 14 15.7501 13.3801 15.7501 12.6154V6.38465C15.7501 6.37933 15.7501 6.37402 15.75 6.36871V7.70003L10.3501 10.64C9.5501 11.12 8.4501 11.12 7.6501 10.64L2.25012 7.70008Z" fill="black"/>
    <path d="M15.75 6.2L10.3501 9.14C9.55007 9.62 8.45007 9.62 7.65007 9.14L2.25 6.2C2.25 5.6 3 5 3.75 5H14.25C15.1442 5 15.75 5.6 15.75 6.2Z" fill="#222222"/>
  </svg>
</template>
